module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074f8_logo_200x200.be8cdb96.png";